/**
 * @desc Yung-通过dicCode获取字典编码列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.BaseDictionaryResponseDto>>;
export function request(
  params: API.basics.baseDictionary.findListByDicCodeList.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/dataDictionary/findListByDicCodeList`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
